import React from 'react'

const tipohorizontalhc = ({photo}) => {
    return (
      <div>
      <div className="flex flex-wrap -mx-4 -mt-4 -mb-10 sm:-m-4">
          <div className="flex flex-col items-center justify-center flex-1 w-1/2 max-w-sm p-6 mx-auto mb-6 transition duration-300 ease-in-out transform md:w-1/3 md:mb-0 focus:outline-none focus:shadow-outline hover:scale-105">
            <div className="w-full h-56 bg-gray-300 bg-center bg-cover rounded-lg shadow-md" >
            <img src={photo} className="object-cover w-full h-56 bg-center bg-cover rounded-lg shadow-md" alt="" />
            </div>

            <div className="p-5 -mt-10 overflow-hidden bg-white rounded-lg shadow-lg w-70">
              
              <div className="inline-flex header-content ">
                <div className="flex-0.5 w-4 h-4 m-1 bg-purple-100 rounded-full category-badge m">
                  <div className="w-2 h-2 m-1 bg-red-500 rounded-full " ></div>
                </div>
                <div className="flex-1 text-sm category-title">Calderas horizontales HC</div>
              </div>
             
            </div>
          </div>
        </div>
    </div>
    )};


export default tipohorizontalhc;